import React from "react";
import styled from "styled-components";
import { Colors } from "../../config/Constants";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

interface ColourProps {
  colour: string;
}

type AttendeesProp = {
  setOpenOrClose: (a: boolean) => void;
  attendeesDetails: {
    Maybe: number;
    No: number;
    Yes: number;
    eventTitle: string;
  };
};

const AttendeesModal = ({
  setOpenOrClose,
  attendeesDetails,
}: AttendeesProp) => {
  const countData =
    attendeesDetails?.Yes || attendeesDetails?.No || attendeesDetails?.Maybe;
  const totalCount =
    attendeesDetails?.Yes + attendeesDetails?.No + attendeesDetails?.Maybe;
  const data = {
    labels: [
      (attendeesDetails?.Yes / totalCount) * 100 + "%",
      (attendeesDetails?.No / totalCount) * 100 + "%",
      (attendeesDetails?.Maybe / totalCount) * 100 + "%",
    ],
    datasets: [
      {
        data: [
          attendeesDetails?.Yes,
          attendeesDetails?.No,
          attendeesDetails?.Maybe,
        ],
        backgroundColor: ["#33CCCC", "#EA3323", "#D9DBDB"],
      },
    ],
  };

  const options: any = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  const labels = [
    {
      colour: "#33CCCC",
      message: "Yes",
      count: attendeesDetails?.Yes,
    },
    {
      colour: "#EA3323",
      message: "No",
      count: attendeesDetails?.No,
    },
    {
      colour: "#D9DBDB",
      message: "Maybe",
      count: attendeesDetails?.Maybe,
    },
  ];

  return (
    <StyledAttendeesModal>
      <AttendeesModalHeader>
        <HeaderTitle>{attendeesDetails?.eventTitle}</HeaderTitle>
        <Close
          src={require("../../assets/images/ei_close.png")}
          alt="close"
          onClick={() => setOpenOrClose(false)}
        />
      </AttendeesModalHeader>
      <AttendeesModalBody>
        {countData ? (
          <>
            <Pie data={data} options={options} height="150px" width="150px" />
            <div>
              {labels.map((label) => (
                <LabelWrapper>
                  <LabelColour colour={label.colour}></LabelColour>
                  <div>
                    <LabelCount>{label.count}</LabelCount>
                    <LabelMessage>{label.message}</LabelMessage>
                  </div>
                </LabelWrapper>
              ))}
            </div>
          </>
        ) : (
          <NoLabel>No Data</NoLabel>
        )}
      </AttendeesModalBody>
    </StyledAttendeesModal>
  );
};

const StyledAttendeesModal = styled.div`
  padding: 1.625rem 2.2rem 1.8rem 2.25rem;
`;
const AttendeesModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;
const HeaderTitle = styled.div`
  font-family: "Poppins-Medium";
  font-size: 1rem;
  color: ${Colors.mineShaft};
`;
const Close = styled.img`
  transform: translate(4.375rem, -0.25rem);
  cursor: pointer;
  margin-right: 3rem;
`;

const AttendeesModalBody = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: end;
`;

const NoLabel = styled.div`
  display: flex;
  margin-top: 0.5rem;
  margin-right: 8rem;
`;

const LabelWrapper = styled.div`
  display: flex;
  margin-top: 0.5rem;
`;

const LabelColour = styled.div<ColourProps>`
  background-color: ${(props) => props.colour};
  width: 4px;
  height: 36px;
  margin-right: 0.5rem;
`;

const LabelCount = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 24px;
  color: #252424;
`;

const LabelMessage = styled.div`
  font-style: normal;
  font-weight: 200;
  font-size: 12px;
  line-height: 16px;
  color: #252424;
`;

export default AttendeesModal;
